module.exports = "\nvec3 objectNormal = vec3( normal );\n"